import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Traffic Flow API
 */
export const wsdotTrafficFlowApiMeta: ApiMeta = {
  name: "wsdot-traffic-flow",
  baseUrl:
    "https://www.wsdot.wa.gov/traffic/api/trafficflow/trafficflowrest.svc",
};
